// same encoding as Surface generate=1

// names, system values and redirect url, like Go url.QueryEscape
export const escapeTagComponent = (value) =>
    encodeURIComponent(String(value)).replace(
        /[!'()*]/g,
        (c) => "%" + c.charCodeAt(0).toString(16).toUpperCase()
    );

export const encodeTagParamName = (name) => escapeTagComponent(name);

// field values: only tag-breaking characters, so partner macros stay intact
const FIELD_VALUE_ESCAPES = {
    " ": "%20", "&": "%26", "#": "%23", "+": "%2B", ";": "%3B",
    '"': "%22", "'": "%27", "<": "%3C", ">": "%3E", "\\": "%5C",
    "\n": "%0A", "\r": "%0D", "\t": "%09",
};

export const encodeFieldValue = (value) =>
    String(value).replace(/[ &#+;"'<>\\\n\r\t]/g, (c) => FIELD_VALUE_ESCAPES[c]);

// script tag property access: a.name for plain identifiers, otherwise a["name"] with the name as entered
export const tagParamAccessor = (name) => {
    const text = String(name);
    return /^[A-Za-z_$][A-Za-z0-9_$]*$/.test(text) ? `a.${text}` : `a[${JSON.stringify(text)}]`;
};
